<template>
  <div class="text-xs-center">
    <v-bottom-sheet persistent v-model="dialog" inset width="500">
      <v-card class="rounded-t-xl">
        <v-card-title primary-title>
          <span>{{ employee.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex class="text-xs-center" v-if="submitLoading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-flex>
        <v-card-text v-else>
          <div class="mt-2">Choose One</div>
          <v-row class="my-5">
            <v-col cols="6">
              <v-card
                color="red"
                @click.stop.prevent="submit('clockedOut')"
                dark
                height="120"
              >
                <v-layout row fill-height align-center justify-center>
                  <v-flex shrink class="text-center">
                    <v-avatar class="red darken-4">
                      <v-icon>mdi-location-exit</v-icon>
                    </v-avatar>
                    <div class="text-h6 text-center">Clock out</div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                color="yellow darken-3"
                @click.stop.prevent="submit('breakStart')"
                dark
                height="120"
              >
                <v-layout row fill-height align-center justify-center>
                  <v-flex shrink class="text-center">
                    <v-avatar right class="yellow darken-4">
                      <v-icon>mdi-coffee-to-go-outline</v-icon>
                    </v-avatar>
                    <div class="text-h6 text-center">Start Break</div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-col>
          </v-row>

          <!-- <span v-if="employee.TimeClocks && employee.TimeClocks[0]">
							<span v-if="employee.TimeClocks[0].status === 'clockedIn'">
								<v-flex>
									<v-layout row>
										<v-btn
											color="error"
											:disabled="submitLoading"
											class="ma-0 btn-size-45 tile"
											style="height: 100%; min-width: 45px !important"
											@click.stop.prevent="submit('clockOut')"
										>
											Clock Out
										</v-btn>
										<v-btn
											color="yellow darken-3"
											:disabled="submitLoading"
											class="ma-0 btn-size-45 tile"
											style="height: 100%; min-width: 45px !important"
											@click.stop.prevent="submit('breakStart')"
										>
											start Break
										</v-btn>
									</v-layout>
								</v-flex>
							</span>
							<span v-else-if="employee.TimeClocks[0] && employee.TimeClocks[0].status === 'breakStart'">
								
								<v-flex>	
									<v-btn
										color="yellow darken-3"
										:loading="submitLoading"
										class="ma-0 btn-size-45 tile"
										style="height: 100%; min-width: 45px !important"
										@click.stop.prevent="submit('endBreak')"
									>
										End Break
									</v-btn>
								</v-flex>
							</span>
							<span v-else >
								<v-flex>	
									<v-btn
										color="green"
										dark
										:loading="submitLoading"
										class="ma-0 btn-size-45 tile"
										style="height: 100%; min-width: 45px !important"
										@click.stop.prevent="submit('clockIn')"
									>
										Clock In
									</v-btn>
								</v-flex>
							</span>
						</span>
						<span v-else>
							<v-flex>	
								<v-btn
									color="green"
									dark
									:loading="submitLoading"
									class="ma-0 btn-size-45 tile"
									style="height: 100%; min-width: 45px !important"
									@click.stop.prevent="submit('clockIn')"
								>
									Clock In
								</v-btn>
							</v-flex>
						</span> -->
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "timeclock-action-dialog",
  props: ["modal", "employee"],
  data() {
    return {
      submitLoading: false,
      dialog: false,
    };
  },
  watch: {
    modal(val) {
      this.dialog = val
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    submit(action) {
      this.submitLoading = true;
      try {
        this.$emit("submit", action);
      } catch (error) {
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 3000,
        });
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
